import { batch } from 'react-redux';
import {
  FETCH_FEED_START,
  FETCH_FEED_FULFILLED,
  FETCH_FEED_REJECTED,
  FETCH_FEED_POST_START,
  FETCH_FEED_POST_FULFILLED,
  FETCH_FEED_POST_REJECTED,
  FETCH_FEED_COUNT_START,
  FETCH_FEED_COUNT_FULFILLED,
  FETCH_FEED_COUNT_REJECTED,
  FETCH_GROUPS_START,
  FETCH_GROUPS_FULFILLED,
  FETCH_GROUPS_REJECTED,
  SET_ACTIVE_REDUX_MODAL,
  UPLOAD_MEDIA_START,
  UPLOAD_MEDIA_FULFILLED,
  UPLOAD_MEDIA_REJECTED,
  SET_UPLOAD_MEDIA,
  SET_UPLOAD_MEDIA_FALSE,
  FETCH_USERS_START,
  FETCH_USERS_FULFILLED,
  FETCH_USERS_REJECTED,
  SET_SUB_ACTIVE_REDUX_MODAL,
  SET_SELECTED_GROUPS,
  SET_SEARCH_STRING,
  FETCH_MORE_FEED_START,
  FETCH_MORE_FEED_FULFILLED,
  FETCH_MORE_FEED_REJECTED,
  SET_IS_FEED_SHOWING,
  SET_FEED_POST_MEDIA_URL,
  UPLOAD_MEDIA_URL_START,
  UPLOAD_MEDIA_URL_FULFILLED,
  UPLOAD_MEDIA_URL_REJECTED,
  SET_ACTIVE_MEDIA_BAR_OB,
  CREATE_FEED_POST_START,
  CREATE_FEED_POST_FULFILLED,
  CREATE_FEED_POST_REJECTED,
  CREATE_FEED_POST_COMMENT_START,
  CREATE_FEED_POST_COMMENT_FULFILLED,
  CREATE_FEED_POST_COMMENT_REJECTED,
  CREATE_FEED_POST_COMMENT_REPLY_START,
  CREATE_FEED_POST_COMMENT_REPLY_FULFILLED,
  CREATE_FEED_POST_COMMENT_REPLY_REJECTED,
  SET_EDIT_MODAL,
  EDIT_FEED_POST_START,
  EDIT_FEED_POST_FULFILLED,
  EDIT_FEED_POST_REJECTED,
  EDIT_FEED_POST_COMMENT_START,
  EDIT_FEED_POST_COMMENT_FULFILLED,
  EDIT_FEED_POST_COMMENT_REJECTED,
  EDIT_FEED_POST_COMMENT_REPLY_START,
  EDIT_FEED_POST_COMMENT_REPLY_FULFILLED,
  EDIT_FEED_POST_COMMENT_REPLY_REJECTED,
  DELETE_FEED_POST_START,
  DELETE_FEED_POST_FULFILLED,
  DELETE_FEED_POST_REJECTED,
  DELETE_FEED_POST_COMMENT_START,
  DELETE_FEED_POST_COMMENT_FULFILLED,
  DELETE_FEED_POST_COMMENT_REJECTED,
  DELETE_FEED_POST_COMMENT_REPLY_START,
  DELETE_FEED_POST_COMMENT_REPLY_FULFILLED,
  DELETE_FEED_POST_COMMENT_REPLY_REJECTED,
  SET_IS_COMMENT_CLICKED_REDUX,
  SET_IS_REPLY_ACTIVATED_REDUX,
  SET_SCROLL_TRUE_FALSE,
  FIST_BUMP_FEED_POST_START,
  FIST_BUMP_FEED_POST_FULFILLED,
  FIST_BUMP_FEED_POST_REJECTED,
  FIST_BUMP_COMMENT_START,
  FIST_BUMP_COMMENT_FULFILLED,
  FIST_BUMP_COMMENT_REJECTED,
  FIST_BUMP_REPLY_START,
  FIST_BUMP_REPLY_FULFILLED,
  FIST_BUMP_REPLY_REJECTED,
  FETCH_PINNED_FEED_START,
  FETCH_PINNED_FEED_FULFILLED,
  FETCH_PINNED_FEED_REJECTED,
  SET_IS_TYPING,
  SET_UNPIN_TOGGLE_FALSE,
  SET_INCOMING_FEED_POST,
  SET_INCOMING_FEED_POST_COMMENT,
  SET_INCOMING_FEED_POST_COMMENT_REPLY,
  SET_IS_TV_MODE,
  FETCH_EXERCISES_START,
  FETCH_EXERCISES_FULFILLED,
  FETCH_EXERCISES_REJECTED,
  FETCH_TOP_PR_START,
  FETCH_TOP_PR_FULFILLED,
  FETCH_TOP_PR_REJECTED,
  EDIT_TOP_PR_START,
  EDIT_TOP_PR_FULFILLED,
  EDIT_TOP_PR_REJECTED,
  DELETE_TOP_PR_WIDGET,
  RESET_TOP_PR_ERROR,
  SET_REPORT_POST_INFO,
  SUBMIT_SUPPORT_START,
  SUBMIT_SUPPORT_FULFILLED,
  SUBMIT_SUPPORT_REJECTED,
  RESET_SUPPORT_ERROR,
} from './actionTypes';

import { axiosAuthed } from '../../../shared/utils/setCommonHeaders';
import { authProvider } from '../../login/ducks/loginActions';
import {
  findCommentIndex,
  findFeedIndex,
  shouldAddToFeed,
  generateErrorMessage,
} from '../helperFunctions';
import { showErrorToast, showSuccessToast } from '../../../shared/utils/toastManager';

authProvider();

export const fetchFeedPRCount = (accountCode) => (dispatch, getState) => {
  const { selectedGroups } = getState().feed.data;
  const groupIds = selectedGroups.map((group) => group.id);
  let uri = `/accounts/${accountCode}/feed/posts/count?prPosts=true`;
  let groupIdString = '';
  if (groupIds && groupIds.length) {
    for (let i = 0; i < groupIds.length; i += 1) {
      groupIdString += `&groupIds[]=${groupIds[i]}`;
    }
  }
  if (groupIdString.length) {
    uri += groupIdString;
  }
  dispatch({ type: FETCH_FEED_COUNT_START });
  axiosAuthed
    .get(uri)
    .then((response) => {
      dispatch({
        payload: response.data.count,
        type: FETCH_FEED_COUNT_FULFILLED,
      });
    })
    .catch((err) => {
      dispatch({
        payload: err,
        type: FETCH_FEED_COUNT_REJECTED,
      });
    });
};

export const fetchFeed = (accountCode) => (dispatch, getState) => {
  const {
    isFeedShowing,
    selectedGroups,
    searchString,
    page: currentPage,
    firstPostId,
  } = getState().feed.data;
  const groupIds = selectedGroups.map((group) => group.id);
  const page = 1;
  const pageSize = 20;
  dispatch({ type: FETCH_FEED_START });
  let uri = `/accounts/${accountCode}/feed/posts?page=${page}&pageSize=${pageSize}`;
  if (searchString?.length) {
    uri += `&search=${searchString}`;
  }
  let groupIdString = '';
  if (groupIds && groupIds.length) {
    for (let i = 0; i < groupIds.length; i += 1) {
      groupIdString += `&groupIds[]=${groupIds[i]}`;
    }
  }
  if (groupIdString.length) {
    uri += groupIdString;
  }
  uri += `&prPosts=${!isFeedShowing}`;
  axiosAuthed
    .get(uri)
    .then((response) => {
      const newFirstPostId = !response.data.length ? null : response.data[0].id;
      if (
        !isFeedShowing
        && currentPage !== 1
        && newFirstPostId === firstPostId
      ) {
        dispatch({
          type: FETCH_FEED_REJECTED,
        });
        return;
      }
      dispatch({
        type: FETCH_FEED_FULFILLED,
        payload: {
          data: response ? response.data : [],
          page,
          firstPostId: newFirstPostId,
        },
      });
    })
    .catch((err) => {
      dispatch({
        type: FETCH_FEED_REJECTED,
        payload: err,
      });
    });
  if (isFeedShowing) {
    dispatch({ type: FETCH_PINNED_FEED_START });
    axiosAuthed
      .get(`${uri}&pinnedPosts=true`)
      .then((response) => {
        dispatch({
          type: FETCH_PINNED_FEED_FULFILLED,
          payload: {
            data: response ? response.data : [],
            page,
          },
        });
      })
      .catch((err) => {
        dispatch({
          type: FETCH_PINNED_FEED_REJECTED,
          payload: err,
        });
      });
  }
  dispatch(fetchFeedPRCount(accountCode));
};

export const fetchMoreFeed = (accountCode, groupIds, searchString) => (
  dispatch,
  getState,
) => {
  const { isFeedShowing } = getState().feed.data;
  const currentPage = getState().feed.data.page;
  const page = currentPage ? currentPage + 1 : 1;
  const pageSize = 20;
  dispatch({ type: FETCH_MORE_FEED_START });
  let uri = `/accounts/${accountCode}/feed/posts?page=${page}&pageSize=${pageSize}`;
  if (searchString.length) {
    uri += `&search=${searchString}`;
  }
  let groupIdString = '';
  if (groupIds && groupIds.length) {
    if (searchString.length) {
      uri += '&';
    }
    groupIdString += `groupIds[]=${groupIds[0]}`;
    for (let i = 1; i < groupIds.length; i += 1) {
      groupIdString += `&groupIds[]=${groupIds[i]}`;
    }
  }
  if (groupIdString.length) {
    uri += groupIdString;
  }
  uri += `&prPosts=${!isFeedShowing}`;
  axiosAuthed
    .get(uri)
    .then((response) => {
      dispatch({
        type: FETCH_MORE_FEED_FULFILLED,
        payload: {
          data: response ? response.data : [],
          page,
        },
      });
    })
    .catch((err) => {
      dispatch({
        type: FETCH_MORE_FEED_REJECTED,
        payload: err,
      });
    });
};

export const fetchGroups = (accountCode) => (dispatch) => {
  dispatch({ type: FETCH_GROUPS_START });
  axiosAuthed
    .get(`/accounts/${accountCode}/groups?messaging=1`)
    .then((response) => {
      dispatch({
        type: FETCH_GROUPS_FULFILLED,
        payload: response.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: FETCH_GROUPS_REJECTED,
        payload: err,
      });
    });
};

export const fetchUsers = (accountCode) => (dispatch) => {
  dispatch({ type: FETCH_USERS_START });
  axiosAuthed
    .get(`/accounts/${accountCode}/users?groupFilter=messaging`)
    .then((response) => {
      dispatch({
        type: FETCH_USERS_FULFILLED,
        payload: response.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: FETCH_USERS_REJECTED,
        payload: err,
      });
    });
};

export const setActiveReduxModal = (activeModal) => ({
  type: SET_ACTIVE_REDUX_MODAL,
  payload: activeModal,
});

export const setSubActiveReduxModal = (activeSubModal) => ({
  type: SET_SUB_ACTIVE_REDUX_MODAL,
  payload: activeSubModal,
});

export const setIsFeedShowing = (bool) => ({
  type: SET_IS_FEED_SHOWING,
  payload: bool,
});

export const setSelectedGroups = (groupArray) => ({
  type: SET_SELECTED_GROUPS,
  payload: groupArray,
});

export const setUploadMedia = (uploadMedia) => ({
  type: SET_UPLOAD_MEDIA,
  payload: uploadMedia,
});

export const setUploadMediaFalse = () => ({
  type: SET_UPLOAD_MEDIA_FALSE,
});

export const setSearchString = (searchString) => ({
  type: SET_SEARCH_STRING,
  payload: searchString,
});

export const openMessageVideo = (mediaUrl) => (dispatch) => {
  batch(() => {
    dispatch({
      type: SET_FEED_POST_MEDIA_URL,
      payload: mediaUrl,
    });
    dispatch({
      type: SET_ACTIVE_REDUX_MODAL,
      payload: 'play-message-video-modal',
    });
  });
};

export const openImageLightbox = (mediaUrl) => (dispatch) => {
  batch(() => {
    dispatch({
      type: SET_FEED_POST_MEDIA_URL,
      payload: mediaUrl,
    });
    dispatch({
      type: SET_ACTIVE_REDUX_MODAL,
      payload: 'image-lightbox',
    });
  });
};

export const uploadMedia = (values) => (dispatch) => {
  const formData = new FormData();
  formData.append(values.type, values.acceptedFile[0]);
  dispatch({ type: UPLOAD_MEDIA_START });
  axiosAuthed
    .post(`/media/upload/${values.type}`, formData)
    .then((response) => {
      dispatch({
        type: UPLOAD_MEDIA_FULFILLED,
        payload: response.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: UPLOAD_MEDIA_REJECTED,
        payload: err,
      });
    });
};

export const uploadMediaUrl = (values, activeMediaBarOb) => (dispatch) => {
  dispatch({ type: UPLOAD_MEDIA_URL_START });
  axiosAuthed
    .post('/media/url', values)
    .then((response) => {
      dispatch({
        type: UPLOAD_MEDIA_URL_FULFILLED,
        payload: {
          data: response.data,
          activeMediaBarOb,
        },
      });
    })
    .catch((err) => {
      dispatch({
        type: UPLOAD_MEDIA_URL_REJECTED,
        payload: err,
      });
    });
};

export const setActiveMediaBarOb = (activeMediaBarOb) => ({
  type: SET_ACTIVE_MEDIA_BAR_OB,
  payload: activeMediaBarOb,
});

export const createFeedPost = (accountCode, values) => async (
  dispatch,
  getState,
) => {
  const { selectedGroups } = getState().feed.data;
  dispatch({ type: CREATE_FEED_POST_START });
  try {
    const response = await axiosAuthed.post(
      `/accounts/${accountCode}/feed/posts`,
      values,
    );
    const add = shouldAddToFeed(
      response.data.groupAccess || [],
      selectedGroups,
    );
    dispatch({
      type: CREATE_FEED_POST_FULFILLED,
      payload: {
        data: response.data,
        add,
      },
    });
  } catch (err) {
    showErrorToast(generateErrorMessage('post', 'creating'));
    dispatch({
      type: CREATE_FEED_POST_REJECTED,
      payload: err,
    });
  }
};

export const createFeedPostComment = (values) => (dispatch) => {
  dispatch({ type: CREATE_FEED_POST_COMMENT_START });
  axiosAuthed
    .post(
      `/accounts/${values.accountCode}/feed/posts/${values.feedObjectId}/comments`,
      values.submissionOb,
    )
    .then((response) => {
      dispatch({
        type: CREATE_FEED_POST_COMMENT_FULFILLED,
        payload: {
          data: response.data,
          index: values.feedObjectIndex,
          scrollTrueId: values.feedObjectId,
          isPinned: values.pinned,
        },
      });
    })
    .catch((err) => {
      showErrorToast(generateErrorMessage('comment', 'creating'));
      dispatch({
        type: CREATE_FEED_POST_COMMENT_REJECTED,
        payload: err,
      });
    });
};

export const setEditModal = (feedObject) => ({
  type: SET_EDIT_MODAL,
  payload: feedObject,
});

export const createFeedPostCommentReply = (values) => (dispatch) => {
  dispatch({ type: CREATE_FEED_POST_COMMENT_REPLY_START });
  axiosAuthed
    .post(
      `/accounts/${values.accountCode}/feed/posts/${values.feedObjectId}/comments/${values.commentObjectId}/replies`,
      values.submissionOb,
    )
    .then((response) => {
      dispatch({
        type: CREATE_FEED_POST_COMMENT_REPLY_FULFILLED,
        payload: {
          data: response.data,
          feedIndex: values.feedObjectIndex,
          commentIndex: values.commentObjectIndex,
          scrollTrueId: values.commentObjectId,
          pinned: values.pinned,
        },
      });
      if (values.onSuccess) {
        values.onSuccess();
      }
    })
    .catch((err) => {
      showErrorToast(generateErrorMessage('reply', 'creating'));
      dispatch({
        type: CREATE_FEED_POST_COMMENT_REPLY_REJECTED,
        payload: err,
      });
    });
};

export const editPost = (values) => (dispatch) => {
  const {
    accountCode,
    feedPostId,
    submissionOb,
    feedIndex,
    oldFeedIndex,
    isUnpinning,
  } = values;
  dispatch({ type: EDIT_FEED_POST_START });
  axiosAuthed
    .put(`/accounts/${accountCode}/feed/posts/${feedPostId}`, submissionOb)
    .then((response) => {
      dispatch({
        type: EDIT_FEED_POST_FULFILLED,
        payload: {
          data: response.data,
          index: feedIndex,
          oldFeedIndex,
          isUnpinning,
        },
      });
    })
    .catch((err) => {
      showErrorToast(generateErrorMessage('post', 'editing'));
      dispatch({
        type: EDIT_FEED_POST_REJECTED,
        payload: err,
      });
    });
};

export const editFeedPostComment = (values) => (dispatch) => {
  dispatch({ type: EDIT_FEED_POST_COMMENT_START });
  axiosAuthed
    .put(
      `/accounts/${values.accountCode}/feed/posts/${values.feedObjectId}/comments/${values.commentObjectId}`,
      values.submissionOb,
    )
    .then((response) => {
      dispatch({
        type: EDIT_FEED_POST_COMMENT_FULFILLED,
        payload: {
          data: response.data,
          feedIndex: values.feedObjectIndex,
          commentIndex: values.commentObjectIndex,
          isPinned: values.isPinned,
        },
      });
    })
    .catch((err) => {
      showErrorToast(generateErrorMessage('comment', 'editing'));
      dispatch({
        type: EDIT_FEED_POST_COMMENT_REJECTED,
        payload: err,
      });
    });
};

export const editFeedPostCommentReply = (values) => (dispatch) => {
  dispatch({ type: EDIT_FEED_POST_COMMENT_REPLY_START });
  axiosAuthed
    .put(
      `/accounts/${values.accountCode}/feed/posts/${values.feedPostId}/comments/${values.commentId}/replies/${values.replyId}`,
      values.submissionOb,
    )
    .then((response) => {
      dispatch({
        type: EDIT_FEED_POST_COMMENT_REPLY_FULFILLED,
        payload: {
          data: response.data,
          feedIndex: values.feedPostIndex,
          commentIndex: values.commentObjectIndex,
          replyIndex: values.replyObjectIndex,
          isPinned: values.isPinned,
        },
      });
    })
    .catch((err) => {
      showErrorToast(generateErrorMessage('reply', 'editing'));
      dispatch({
        type: EDIT_FEED_POST_COMMENT_REPLY_REJECTED,
        payload: err,
      });
    });
};

export const deleteFeedPost = (values) => (dispatch) => {
  dispatch({ type: DELETE_FEED_POST_START });
  axiosAuthed
    .patch(`/accounts/${values.accountCode}/feed/posts/delete`, {
      postIds: [values.feedObjectId],
    })
    .then((response) => {
      dispatch({
        type: DELETE_FEED_POST_FULFILLED,
        payload: {
          data: response.data,
          index: values.feedObjectIndex,
          isPinned: values.pinned,
          feedPostId: values.feedObjectId,
        },
      });
    })
    .catch((err) => {
      showErrorToast(generateErrorMessage('post', 'deleting'));
      dispatch({
        type: DELETE_FEED_POST_REJECTED,
        payload: err,
      });
    });
};

export const deleteFeedPostComment = (values) => (dispatch) => {
  dispatch({ type: DELETE_FEED_POST_COMMENT_START });
  axiosAuthed
    .patch(`/accounts/${values.accountCode}/feed/posts/delete`, {
      postIds: [values.commentId],
    })
    .then((response) => {
      dispatch({
        type: DELETE_FEED_POST_COMMENT_FULFILLED,
        payload: {
          data: response.data,
          feedIndex: values.feedIndex,
          commentIndex: values.commentIndex,
          isPinned: values.pinned,
          commentId: values.commentId,
        },
      });
    })
    .catch((err) => {
      showErrorToast(generateErrorMessage('comment', 'deleting'));
      dispatch({
        type: DELETE_FEED_POST_COMMENT_REJECTED,
        payload: err,
      });
    });
};

export const deleteFeedPostCommentReply = (values) => (dispatch) => {
  dispatch({ type: DELETE_FEED_POST_COMMENT_REPLY_START });
  axiosAuthed
    .patch(`/accounts/${values.accountCode}/feed/posts/delete`, {
      postIds: [values.replyId],
    })
    .then((response) => {
      dispatch({
        type: DELETE_FEED_POST_COMMENT_REPLY_FULFILLED,
        payload: {
          data: response.data,
          feedIndex: values.feedIndex,
          commentIndex: values.commentIndex,
          replyIndex: values.replyIndex,
          isPinned: values.pinned,
          replyId: values.replyId,
        },
      });
    })
    .catch((err) => {
      showErrorToast(generateErrorMessage('reply', 'deleting'));
      dispatch({
        type: DELETE_FEED_POST_COMMENT_REPLY_REJECTED,
        payload: err,
      });
    });
};

export const fetchFeedPost = (values) => (dispatch) => {
  dispatch({ type: FETCH_FEED_POST_START });
  axiosAuthed
    .get(`/accounts/${values.accountCode}/feed/posts/${values.postId}`)
    .then((response) => {
      dispatch({
        type: FETCH_FEED_POST_FULFILLED,
        payload: {
          data: response.data,
        },
      });
    })
    .catch((err) => {
      showErrorToast(generateErrorMessage('post', 'fetching'));
      dispatch({
        type: FETCH_FEED_POST_REJECTED,
        payload: err,
      });
    });
};

export const setIsCommentClickedRedux = (isCommentClickedOb) => ({
  type: SET_IS_COMMENT_CLICKED_REDUX,
  payload: isCommentClickedOb,
});

export const setIsReplyActivatedRedux = (isReplyActivatedOb) => ({
  type: SET_IS_REPLY_ACTIVATED_REDUX,
  payload: isReplyActivatedOb,
});

export const setScrollTrueFalse = () => ({
  type: SET_SCROLL_TRUE_FALSE,
});

export const fistBumpFeedPost = (values) => (dispatch) => {
  dispatch({ type: FIST_BUMP_FEED_POST_START });
  axiosAuthed
    .post(`/accounts/${values.accountCode}/feed/posts/fist-bump`, {
      active: values.bool,
      postId: values.feedPostId,
    })
    .then((response) => {
      dispatch({
        type: FIST_BUMP_FEED_POST_FULFILLED,
        payload: {
          data: response.data,
          feedIndex: values.feedObjectIndex,
          bool: values.bool,
          pinned: values.pinned,
        },
      });
      if (values.onSuccess) {
        values.onSuccess(response.data.fistBumpActive, response.data.fistBumps);
      }
    })
    .catch((err) => {
      showErrorToast(generateErrorMessage());
      dispatch({
        type: FIST_BUMP_FEED_POST_REJECTED,
        payload: err,
      });
    });
};

export const fistBumpComment = (values) => (dispatch) => {
  dispatch({ type: FIST_BUMP_COMMENT_START });
  axiosAuthed
    .post(`/accounts/${values.accountCode}/feed/posts/fist-bump`, {
      active: values.bool,
      postId: values.commentId,
    })
    .then((response) => {
      dispatch({
        type: FIST_BUMP_COMMENT_FULFILLED,
        payload: {
          data: response.data,
          feedIndex: values.feedObjectIndex,
          commentIndex: values.commentObjectIndex,
          bool: values.bool,
          pinned: values.pinned,
        },
      });
      if (values.onSuccess) {
        values.onSuccess(response.data.fistBumpActive, response.data.fistBumps);
      }
    })
    .catch((err) => {
      showErrorToast(generateErrorMessage());
      dispatch({
        type: FIST_BUMP_COMMENT_REJECTED,
        payload: err,
      });
    });
};

export const fistBumpReply = (values) => (dispatch) => {
  dispatch({ type: FIST_BUMP_REPLY_START });
  axiosAuthed
    .post(`/accounts/${values.accountCode}/feed/posts/fist-bump`, {
      active: values.bool,
      postId: values.replyId,
    })
    .then((response) => {
      dispatch({
        type: FIST_BUMP_REPLY_FULFILLED,
        payload: {
          data: response.data,
          feedIndex: values.feedObjectIndex,
          commentIndex: values.commentObjectIndex,
          replyIndex: values.replyObjectIndex,
          bool: values.bool,
          pinned: values.pinned,
        },
      });
      if (values.onSuccess) {
        values.onSuccess(response.data.fistBumpActive, response.data.fistBumps);
      }
    })
    .catch((err) => {
      showErrorToast(generateErrorMessage());
      dispatch({
        type: FIST_BUMP_REPLY_REJECTED,
        payload: err,
      });
    });
};

export const setUnPinToggleFalse = () => ({
  type: SET_UNPIN_TOGGLE_FALSE,
});

export const setIncomingFeedPost = (incomingFeedPost) => (
  dispatch,
  getState,
) => {
  const { selectedGroups } = getState().feed.data;
  const { currentUser } = getState().auth.data;

  const add = currentUser.id !== incomingFeedPost.userId
    ? shouldAddToFeed(incomingFeedPost.groupAccess || [], selectedGroups)
    : false;

  dispatch({
    type: SET_INCOMING_FEED_POST,
    payload: {
      data: incomingFeedPost,
      add,
    },
  });
};

export const setIncomingFeedPostComment = (incomingFeedPostComment) => (
  dispatch,
  getState,
) => {
  const { feed, pinnedFeed } = getState().feed.data;
  const { currentUser } = getState().auth.data;
  if (currentUser.id !== incomingFeedPostComment.userId) {
    const feedPostIsPinned = pinnedFeed.some(
      (feedItem) => feedItem.id === incomingFeedPostComment.postId,
    );
    const feedObject = {
      id: incomingFeedPostComment.postId,
      pinned: feedPostIsPinned,
    };
    const feedObjectIndex = findFeedIndex(feedObject, feed, pinnedFeed);

    dispatch({
      type: SET_INCOMING_FEED_POST_COMMENT,
      payload: {
        data: incomingFeedPostComment,
        feedPostIndex: feedObjectIndex,
        isPinned: feedPostIsPinned,
      },
    });
  }
};

export const setIncomingFeedPostCommentReply = (
  incomingFeedPostCommentReply,
) => async (dispatch, getState) => {
  const { feed, pinnedFeed } = getState().feed.data;
  const { currentUser } = getState().auth.data;

  if (currentUser.id === incomingFeedPostCommentReply.userId) return;

  const feedPostIsPinned = pinnedFeed.some(
    (feedItem) => feedItem.id === incomingFeedPostCommentReply.postId,
  );
  const feedObject = feedPostIsPinned
    ? pinnedFeed.find(
      (feedItem) => feedItem.id === incomingFeedPostCommentReply.postId,
    )
    : feed.find(
      (feedItem) => feedItem.id === incomingFeedPostCommentReply.postId,
    );
  const feedObjectIndex = findFeedIndex(feedObject, feed, pinnedFeed);

  const commentObject = {
    id: incomingFeedPostCommentReply.postCommentId,
  };

  const commentIndex = findCommentIndex(commentObject, feedObject);

  dispatch({
    type: SET_INCOMING_FEED_POST_COMMENT_REPLY,
    payload: {
      data: incomingFeedPostCommentReply,
      feedPostIndex: feedObjectIndex,
      feedPostCommentIndex: commentIndex,
      isPinned: feedPostIsPinned,
    },
  });
};

export const setIsTyping = (typingObject) => (dispatch) => {
  dispatch({
    type: SET_IS_TYPING,
    payload: {
      data: typingObject,
    },
  });
};

export const setIsTvMode = (boolean) => (dispatch) => {
  dispatch({
    type: SET_IS_TV_MODE,
    payload: boolean,
  });
};

export const deleteTopPrWidget = (id) => (dispatch) => {
  dispatch({
    type: DELETE_TOP_PR_WIDGET,
    payload: id,
  });
};

export const fetchExercises = (accountCode, exerciseType) => (dispatch) => {
  dispatch({ type: FETCH_EXERCISES_START });
  axiosAuthed
    .get(`/accounts/${accountCode}/exercises?type=${exerciseType}&tracked=1`)
    .then((response) => {
      dispatch({
        type: FETCH_EXERCISES_FULFILLED,
        payload: response.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: FETCH_EXERCISES_REJECTED,
        payload: err,
      });
    });
};

export const resetTopPrError = () => (dispatch) => {
  dispatch({ type: RESET_TOP_PR_ERROR });
};

export const fetchTopPr = (values, actionType) => (dispatch, getState) => {
  const { topPrWidgets } = getState().feed.data;
  const {
    accountCode,
    exerciseId,
    exerciseName,
    gender,
    rangeType,
    groups,
    mustBeInAllGroups,
    id,
  } = values;

  const duplicate = topPrWidgets.some(
    (topPrObj) => topPrObj.values.exerciseId === exerciseId
      && topPrObj.values.gender === gender,
  );

  const page = 1;

  const accountString = `/accounts/${accountCode}`;
  const exerciseQuery = `/exercises/${exerciseId}/`;
  const leaderboardQuery = `leaderboard?page=${page}&pageSize=1`;
  const genderQuery = `${gender ? `&gender=${gender}` : ''}`;
  const rangeQuery = `&rangeType=${rangeType}`;
  const rangeDatesQuery = '';
  const compareToQuery = '';
  const compareDatesQuery = '';
  const downloadQuery = '';
  const groupsQuery = `${
    groups.length !== 0
      ? `${groups.map((group) => `&groupIds[]=${group.id}`).join('')}`
      : ''
  }`;
  const allGroups = `${
    groups.length !== 0 ? `&mustBeInAllGroups=${mustBeInAllGroups}` : ''
  }`;

  if (actionType === 'add') {
    dispatch({ type: FETCH_TOP_PR_START });
  }
  if (actionType === 'edit') {
    dispatch({ type: EDIT_TOP_PR_START });
  }

  if (duplicate && actionType === 'add') {
    return dispatch({
      type: FETCH_TOP_PR_REJECTED,
      payload: {
        type: 'duplicate',
        err:
          'You are already displaying this information. Please select again.',
      },
    });
  }

  return axiosAuthed
    .get(
      `${accountString}${exerciseQuery}${leaderboardQuery}${genderQuery}${groupsQuery}${allGroups}${rangeQuery}${rangeDatesQuery}${compareToQuery}${compareDatesQuery}${downloadQuery}`,
    )
    .then((response) => {
      if (actionType === 'add') {
        batch(() => {
          dispatch({
            type: FETCH_TOP_PR_FULFILLED,
            payload: {
              data: response ? response.data : [],
              exerciseName,
              values,
              errorMessage: '',
            },
          });
          dispatch(setActiveReduxModal(''));
          dispatch(resetTopPrError());
        });
      }
      if (actionType === 'edit') {
        dispatch({
          type: EDIT_TOP_PR_FULFILLED,
          payload: {
            data: response ? response.data : [],
            exerciseName,
            values,
            errorMessage: '',
          },
        });
      }
    })
    .catch((err) => {
      if (actionType === 'add') {
        dispatch({
          type: FETCH_TOP_PR_REJECTED,
          payload: {
            type: 'no_athletes',
            err,
          },
        });
      }
      if (actionType === 'edit') {
        dispatch({
          type: EDIT_TOP_PR_REJECTED,
          payload: {
            type: 'no_athletes',
            id,
            err,
          },
        });
      }
    });
};

export const setReportPostInfo = (
  type,
  postId,
  commentId = null,
  replyId = null,
) => (dispatch) => {
  dispatch({
    type: SET_REPORT_POST_INFO,
    payload: {
      type,
      postId,
      commentId,
      replyId,
    },
  });
};

export const resetReportPostInfo = () => (dispatch) => {
  dispatch({
    type: SET_REPORT_POST_INFO,
    payload: {},
  });
};

export const submitSupport = (values) => (dispatch) => {
  dispatch({ type: SUBMIT_SUPPORT_START });
  axiosAuthed
    .post('/support', values)
    .then((response) => {
      dispatch({
        type: SUBMIT_SUPPORT_FULFILLED,
        payload: response.data,
      });
      showSuccessToast('Message submitted successfully. Thank you.');
    })
    .catch((err) => {
      dispatch({
        type: SUBMIT_SUPPORT_REJECTED,
        payload: err,
      });
      showErrorToast('There was an error submitting your message. Please try again.');
    });
};

export const resetSubmitSupportError = () => (dispatch) => {
  dispatch({ type: RESET_SUPPORT_ERROR });
};
